/* esm.sh - @use-gesture/core@10.3.1/dist/actions-fe213e88.esm */
export * from "/*@use-gesture/core@10.3.1/esnext/dist/actions-fe213e88.esm.mjs";
